import {
	Column,
	Entity,
	Index,
	JoinColumn,
	ManyToOne,
	OneToMany,
} from 'typeorm';
import { BaseEntity } from './base.entity';
import { ClientListClientEntity } from './client-list-client.entity';
import type { ClientListRoleEntity } from './client-list-role.entity';
import { UserEntity } from './user.entity';

export type ClientListVisibility = 'private' | 'role' | 'organization';

@Index('idx_client_list_deleted', ['deletedDate'], {})
@Index('idx_client_list_visibility', ['visibility'])
@Index('idx_client_list_manager', ['managerUserId'])
@Entity('client_list')
export class ClientListEntity extends BaseEntity {
	@Column('varchar', { name: 'name', length: 255 })
	public name!: string;

	@Column('text', { name: 'description', nullable: true })
	public description!: string | null;

	@Column('enum', {
		name: '_visibility',
		enum: ['private', 'role', 'organization'],
		default: 'private',
	})
	public visibility!: ClientListVisibility;

	@Column('int', {
		name: '_fk_manager_user__id',
		unsigned: true,
		nullable: true,
	})
	public managerUserId!: number | null;

	@ManyToOne(() => UserEntity, {
		onDelete: 'CASCADE',
		onUpdate: 'RESTRICT',
	})
	@JoinColumn([{ name: '_fk_manager_user__id', referencedColumnName: 'id' }])
	public manager!: UserEntity | null;

	@Column('tinyint', { name: '_allow_edit', width: 1, default: () => "'0'" })
	public allowEdit!: boolean;

	@OneToMany(
		() => ClientListClientEntity,
		(clientListClient) => clientListClient.fkClientList,
		{},
	)
	public clientListClients!: Array<ClientListClientEntity>;

	@OneToMany(
		'ClientListRoleEntity',
		(role: ClientListRoleEntity) => role.clientList,
	)
	public sharedRoles!: Array<ClientListRoleEntity>;
}
